import React from 'react';
import { FaGithub } from 'react-icons/fa';

export default function ProjectCard({ title, description, stack = [], github, image, link }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="block transition-transform transform hover:scale-[1.03]"
    >
      <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl duration-300">
        <div className="relative w-full h-52 overflow-hidden">
          {image ? (
            <img src={image} alt={title} className="w-full h-full object-cover object-center" />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center text-xl text-slate-400">
              Coming Soon
            </div>
          )}
        </div>

        <div className="p-5">
          <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
          <p className="text-slate-300 text-sm mb-4 leading-relaxed">{description}</p>

          <div className="flex flex-wrap gap-2 mb-4">
            {stack.map((tech, idx) => (
              <span
                key={idx}
                className="bg-slate-700/50 text-slate-200 px-3 py-1 rounded-full text-xs backdrop-blur-sm border border-slate-500/20"
              >
                {tech}
              </span>
            ))}
          </div>

          {github && (
            <div
              onClick={(e) => e.stopPropagation()}
              className="mt-2"
            >
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
              >
                <FaGithub className="text-lg" /> GitHub
              </a>
            </div>
          )}
        </div>
      </div>
    </a>
  );
}
